import produce from 'immer';
import { AnyAction } from 'redux';
import { GET_RECEIPT_REQUEST, GET_RECEIPT_SUCCESS, GET_RECEIPT_FAILURE, GET_RECEIPT_INITIAL } from '../../actions';

// タイプを設定
export type GetReceiptStateType = {
  isGetReceiptLoading: boolean;
  isGetReceiptLoaded: boolean;
  getReceipt: GetReceiptType;
};

type GetReceiptType = {
  result: number;
  recipientName: string | null;
  clauseTitle: string | null;
};

// ステイタスを初期化
const initialState: GetReceiptStateType = {
  isGetReceiptLoading: false,
  isGetReceiptLoaded: false,
  getReceipt: {
    result: -1,
    recipientName: '',
    clauseTitle: '',
  },
};

// APIの結果によってステイタスが更新される処理
const getReceiptReducer = (state = initialState, action: AnyAction): GetReceiptStateType => {
  return produce(state, (draft) => {
    const dataState = draft;
    switch (action.type) {
      case GET_RECEIPT_REQUEST:
        dataState.isGetReceiptLoading = true;
        dataState.isGetReceiptLoaded = false;
        dataState.getReceipt.result = -1;
        dataState.getReceipt.recipientName = '';
        dataState.getReceipt.clauseTitle = '';
        break;
      case GET_RECEIPT_SUCCESS:
        dataState.isGetReceiptLoading = false;
        dataState.isGetReceiptLoaded = true;
        dataState.getReceipt.result = action.res.data.result;
        dataState.getReceipt.recipientName = action.res.data.recipient_name;
        dataState.getReceipt.clauseTitle = action.res.data.clause_title;
        break;
      case GET_RECEIPT_FAILURE:
        dataState.isGetReceiptLoading = false;
        dataState.isGetReceiptLoaded = false;
        dataState.getReceipt.result = -1;
        dataState.getReceipt.recipientName = '';
        dataState.getReceipt.clauseTitle = '';
        break;
      case GET_RECEIPT_INITIAL:
        dataState.isGetReceiptLoading = false;
        dataState.isGetReceiptLoaded = false;
        dataState.getReceipt.result = -1;
        dataState.getReceipt.recipientName = '';
        dataState.getReceipt.clauseTitle = '';
        break;
      default:
        break;
    }
  });
};

export default getReceiptReducer;
